import type { ElementTweenFunction } from '../types';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';

export const dropFromTop: ElementTweenFunction = ({ target,
    options,
    scrollTrigger,
    direction
}
) => {
    if (direction === "back") return { tween: undefined, position: "0" }
    const duration = options?.duration ? options.duration : .75
    const ease = options?.ease ? options.ease : 'expo.out'
    const tween = gsap.fromTo(
        target,
        { y: '-700%' }, // Start above the viewport
        { y: '0', duration: duration, ease, }, // Drop down quickly
    )


    if (scrollTrigger?.trigger) {
        ScrollTrigger.create({
            animation: tween,
            ...scrollTrigger,
        });
    }

    return { tween, position: ">" }
};
